export const LOAD_LOCATIONS_PENDING = 'LOAD_LOCATIONS_PENDING';
export const LOAD_LOCATIONS_FULFILLED = 'LOAD_LOCATIONS_FULFILLED';
export const LOAD_LOCATIONS_REJECTED = 'LOAD_LOCATIONS_REJECTED';
export const LOAD_LOCATIONS = 'LOAD_LOCATIONS';
export const SET_LOCATIONS = 'SET_LOCATIONS';
